export const notNil = <T>(input: T | null | undefined): input is T =>
  input !== null && input !== undefined;

export const isNil = <T>(input: T | null | undefined): input is null | undefined =>
  input === null || input === undefined;

export function unlessNil<Input, Result>(
  value: Input | null | undefined,
  fn: (value: Input) => Result,
): Result | undefined {
  if (value === null || value === undefined) {
    return;
  }

  return fn(value);
}

// crypto.randomUUID is only available in secure contexts; fall back to a
// getRandomValues-based v4 UUID elsewhere (e.g. the exploration-export
// renderer reaching the app over plain http).
export const generateUUID = () => {
  if (typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
